module.exports = __webpack_public_path__ + "static/media/1.39a69771.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/1.svg
// module id = 125
// module chunks = 0